var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 2.75a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zM5.248 8a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0zm-.433 11.626c-.735.797-1.067 1.746-1.067 2.374a.75.75 0 01-1.5 0c0-1.06.513-2.36 1.465-3.392.973-1.053 2.433-1.858 4.347-1.858h7.875c1.915 0 3.375.805 4.348 1.858.952 1.032 1.465 2.333 1.465 3.392a.75.75 0 01-1.5 0c0-.628-.332-1.578-1.067-2.374-.715-.774-1.786-1.376-3.246-1.376H8.06c-1.458 0-2.53.602-3.245 1.376z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.eb7e711a8d338234db3b3be7abc8bcb2.svg";
export { ForwardRef as ReactComponent };